export interface Column<T> {
  label: string;
  key?: keyof T;
  render?: (row: T) => string;
  className?: string;
}

export function createDataTable<T>(columns: Column<T>[], rows: T[], opts?: { onRowClick?: (row: T) => void; emptyText?: string }): HTMLElement {
  const wrapper = document.createElement('div');
  wrapper.className = 'overflow-x-auto';

  if (rows.length === 0) {
    wrapper.innerHTML = `<div class="text-center py-12 text-gray-400">${opts?.emptyText || 'No data found.'}</div>`;
    return wrapper;
  }

  const table = document.createElement('table');
  table.className = 'data-table';

  const thead = document.createElement('thead');
  thead.innerHTML = `<tr>${columns.map(c => `<th class="${c.className || ''}">${c.label}</th>`).join('')}</tr>`;
  table.appendChild(thead);

  const tbody = document.createElement('tbody');
  rows.forEach(row => {
    const tr = document.createElement('tr');
    if (opts?.onRowClick) {
      tr.className = 'cursor-pointer hover:bg-gray-50';
      tr.addEventListener('click', () => opts.onRowClick!(row));
    }
    tr.innerHTML = columns.map(c => {
      const val = c.render ? c.render(row) : (c.key ? String((row as Record<string, unknown>)[c.key as string] ?? '') : '');
      return `<td class="${c.className || ''}">${val}</td>`;
    }).join('');
    tbody.appendChild(tr);
  });
  table.appendChild(tbody);
  wrapper.appendChild(table);
  return wrapper;
}
